import React from 'react';
import { Globe, Smartphone, Layout, Settings, Code, MonitorSmartphone, Megaphone, ArrowRight, Newspaper } from 'lucide-react';
import { useLang } from '@/i18n/LangContext';

export default function ServicesSection() {
  const { t } = useLang();
  const services = [
    { icon: Globe, title: t.services.s1, description: t.services.s1d, span: 'md:col-span-7' },
    { icon: Layout, title: t.services.s2, description: t.services.s2d, span: 'md:col-span-5' },
    { icon: Code, title: t.services.s3, description: t.services.s3d, span: 'md:col-span-5' },
    { icon: Smartphone, title: t.services.s4, description: t.services.s4d, span: 'md:col-span-7' },
    { icon: MonitorSmartphone, title: t.services.s5, description: t.services.s5d, span: 'md:col-span-7' },
    { icon: Settings, title: t.services.s6, description: t.services.s6d, span: 'md:col-span-5' },
  ];

  const scrollTo = (id) => { const el = document.querySelector(id); if (el) el.scrollIntoView({ behavior: 'smooth' }); };

  return (
    <section id="services" data-testid="services-section" className="py-24 md:py-32 bg-[#F3F5F7]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#00D186] mb-4 block">{t.services.label}</span>
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight leading-tight text-[#0B132B] mb-4">{t.services.title1}<br /><span className="text-gradient">{t.services.title2}</span></h2>
          <p className="text-base md:text-lg text-[#475569] max-w-2xl mx-auto">{t.services.desc}</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          {services.map((service, i) => (
            <div key={i} data-testid={`service-card-${i}`} className={`${service.span} bg-white border border-[#E2E8F0] rounded-xl p-8 md:p-10 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl group`}>
              <div className="w-14 h-14 rounded-xl bg-[#0B132B] flex items-center justify-center mb-6 group-hover:bg-[#00D186] transition-colors duration-300">
                <service.icon size={26} className="text-[#00D186] group-hover:text-[#0B132B] transition-colors duration-300" />
              </div>
              <h3 className="text-xl font-bold text-[#0B132B] mb-3">{service.title}</h3>
              <p className="text-[#475569] leading-relaxed">{service.description}</p>
            </div>
          ))}
          {/* Press Release Service - Full width highlight */}
          <div data-testid="service-card-press" className="md:col-span-12 bg-[#0B132B] border border-white/10 rounded-xl p-8 md:p-10 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl group relative overflow-hidden">
            <div className="absolute top-0 right-0 w-64 h-64 bg-[#00D186]/5 rounded-full -translate-y-1/2 translate-x-1/2" />
            <div className="relative z-10 grid grid-cols-1 lg:grid-cols-3 gap-8 items-center">
              <div className="lg:col-span-2">
                <div className="w-14 h-14 rounded-xl bg-[#00D186] flex items-center justify-center mb-6">
                  <Megaphone size={26} className="text-[#0B132B]" />
                </div>
                <h3 className="text-xl font-bold text-white mb-3">{t.services.s7}</h3>
                <p className="text-[#94A3B8] leading-relaxed mb-6">{t.services.s7d}</p>
                <p className="text-xs text-[#94A3B8]/70 italic">{t.services.s7note}</p>
              </div>
              <div className="flex flex-col gap-3">
                <button onClick={() => scrollTo('#contact')} data-testid="service-press-contact" className="inline-flex items-center justify-center gap-2 px-6 py-3.5 bg-[#00D186] text-[#0B132B] font-bold rounded-sm transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg hover:shadow-[#00D186]/20 text-sm">
                  <ArrowRight size={16} /> {t.services.s7cta1}
                </button>
                <button onClick={() => scrollTo('#blog')} data-testid="service-press-publications" className="inline-flex items-center justify-center gap-2 px-6 py-3.5 border border-white/20 text-white font-bold rounded-sm transition-all duration-300 hover:bg-white/5 text-sm">
                  <Newspaper size={16} /> {t.services.s7cta2}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
